import { MODULE_NAME } from '../constants';

export const GET_FILTERS_BY_CATEGORY = `${MODULE_NAME}/GET_FILTERS_BY_CATEGORY`;
export const GET_FILTERS_BY_CATEGORY_SUCCESS = `${MODULE_NAME}/GET_FILTERS_BY_CATEGORY_SUCCESS`;
export const GET_FILTERS_BY_CATEGORY_ERROR = `${MODULE_NAME}/GET_FILTERS_BY_CATEGORY_ERROR`;
export const GET_STRUCTURED_SPECS_CONFIG_SUCCESS = `${MODULE_NAME}/GET_STRUCTURED_SPECS_CONFIG_SUCCESS`;
export const GET_STRUCTURED_SPECS_CONFIG_ERROR = `${MODULE_NAME}/GET_STRUCTURED_SPECS_CONFIG_ERROR`;

export const SET_FILTERS_VISIBLE = `${MODULE_NAME}/SET_FILTERS_VISIBLE`;
